import CheckboxDropdown from '@/components/CheckboxDropdown'
import { memo, useContext, useEffect } from 'react'
import { TaskListContext } from '..'
import { setTaskState } from '../task-context'

const TaskFilter = memo<any>(function (props) {
  const { dispatch, columns, checkedFields } = useContext(TaskListContext)
  const fieldOptions = columns
    .filter((item) => !['num'].includes(item.key))
    .map((item) => ({
      value: item.key,
      label: item.title
    }))

  useEffect(() => {
    const keys = columns.map((item) => item.key)
    dispatch(
      setTaskState({
        checkedFields: keys
      })
    )
  }, [])

  return (
    <CheckboxDropdown
      {...props}
      title='Task field'
      options={fieldOptions}
      value={checkedFields}
      onChange={(keys: number[]) => {
        dispatch(setTaskState({ checkedFields: keys }))
      }}
    />
  )
})

export default TaskFilter
